export enum EventConstants {
    GET_LAST_EVENTS = "GET_LAST_EVENTS",
    ERROR = "ERROR",
}